module.exports = __webpack_public_path__ + "img/feature_buy_ko.a1c1d516.png";